@if (disabilityTypes().length > 0) {
	<section class="lvr-shared-list">
		<div class="lvr-shared-list__header">
			<h3>{{ 'client.disability.types' | transloco }}</h3>
		</div>
		<div class="lvr-shared-list__body">
			@for (item of disabilityTypes(); track item.id) {
				<a class="lvr-shared-list__record link" [routerLink]="['type', item.id]">
					<lvr-disability-type-item [disabilityType]="item"></lvr-disability-type-item>
				</a>
			}
		</div>
		<lvr-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="showFirstLastButtons()"
			[hidePageSize]="hidePageSize()"
			preferenceKey="disability-type-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	</section>
} @else {
	<h3 style="padding-top: 32px">{{ 'client.disability.types' | transloco }}</h3>
	<p>{{ 'client.disability.no_types' | transloco }}</p>
}
